import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";

import { AuthLayout } from "~/components/layouts/AuthLayout";
import { CasePage } from "~/pages/CasePage";
import { CasesPage } from "~/pages/CasesPage";
import { LoginPage } from "~/pages/LoginPage";
import { RegisterPage } from "~/pages/RegisterPage";
import { RootPage } from "~/pages/RootPage";
import { SkyViewPage } from "~/pages/SkyViewPage";
import { TranscribingPage } from "~/pages/transcribing/TranscribingPage";
import { SettingsReports } from "./features/settings/components/reports";
import { SettingsAccount } from "./features/settings/components/SettingsAccount";
import { SettingsAppearance } from "./features/settings/components/SettingsAppearance";
import { SettingsArchived } from "./features/settings/components/SettingsArchive";
import { SettingsCategories } from "./features/settings/components/SettingsCategories";
import { SettingsDevelopers } from "./features/settings/components/SettingsDevelopers";
import { SettingsKnowledge } from "./features/settings/components/SettingsKnowledge";
import { SettingsOrganization } from "./features/settings/components/SettingsOrganization";
import { SettingsTeam } from "./features/settings/components/SettingsTeam";
import { SettingsUsage } from "./features/settings/components/SettingsUsage";
import { ChangePasswordPage } from "./pages/ChangePasswordPage";
import { DemoCaseGenerationPage } from "./pages/demoCase/DemoCaseGenerationPage";
import { DemoCaseUploadPage } from "./pages/demoCase/DemoCaseUploadPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { PaymentSuccessPage } from "./pages/PaymentSuccessPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { SettingsPage } from "./pages/SettingsPage";

import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import { AppLayout } from "./components/layouts/AppLayout";
import { logCurrentStage } from "./lib/utils";

logCurrentStage();

const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: <RootPage />,
      },
      {
        path: "/organizations/:organizationId/demo-case-generation",
        element: <DemoCaseGenerationPage />,
      },
      {
        path: "/organizations/:organizationId/cases/:caseId/demo-case-generation",
        element: <DemoCaseUploadPage />,
      },
      {
        path: "/organizations/:organizationId/cases",
        element: <CasesPage />,
      },
      {
        path: "/organizations/:organizationId/cases/:caseId",
        element: <CasePage />,
      },
      {
        path: "/organizations/:organizationId/cases/:caseId/chat/:chatId",
        element: <SkyViewPage />,
      },
      {
        path: "/organizations/:organizationId/settings",
        element: <SettingsPage />,
        children: [
          {
            path: "account",
            element: <SettingsAccount />,
          },
          {
            path: "appearance",
            element: <SettingsAppearance />,
          },
          {
            path: "organization",
            element: <SettingsOrganization />,
          },
          {
            path: "archived",
            element: <SettingsArchived />,
          },
          {
            path: "categoriesManagement",
            element: <SettingsCategories />,
          },
          {
            path: "usage",
            element: <SettingsUsage />,
          },
          {
            path: "team",
            element: <SettingsTeam />,
          },
          {
            path: "knowledge",
            element: <SettingsKnowledge />,
          },
          {
            path: "reports",
            element: <SettingsReports />,
          },
          {
            path: "developers",
            element: <SettingsDevelopers />,
          },
        ],
      },
      {
        path: "/billing/success",
        element: <PaymentSuccessPage />,
      },
    ],
  },
  {
    element: <AuthLayout />,
    children: [
      {
        path: "/",
        element: <Navigate to="/login" />,
      },
      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        path: "/register",
        element: <RegisterPage />,
      },
      {
        path: "/forgot-password",
        element: <ForgotPasswordPage />,
      },
      {
        path: "/reset-password",
        element: <ResetPasswordPage />,
      },
      {
        path: "/change-password",
        element: <ChangePasswordPage />,
      },
    ],
  },
  {
    element: <TranscribingPage />,
    path: "/transcribing",
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export { App };
